import { createContext } from 'react';

export type SelectFlowContextType = {
  mode: 'guest' | 'authorized';
  configureFlow: (nodeId: string) => void;
  workspaceId?: string;
  teamId?: string;
};

export const SelectFlowContext = createContext<SelectFlowContextType>({
  mode: 'guest',
  configureFlow: (nodeId: string) => null,
});
